export const detectRoute = () => {
  return window.location.pathname;
};

export const detectEnvironment = () => {
  const domain = window.location.origin;
  const options = ['local', 'dev', 'qa', 'uat'];
  let environment = 'prod';
  options.forEach((env: string) => {
    if (domain.indexOf(env) !== -1) {
      environment = env;
    }
  });
  return environment;
};

const overwriteStorage = (key?: string, value?: any) => {
  const newSave: any = {
    environment: detectEnvironment(),
  };
  if (key) {
    newSave[key] = value;
  }
  window.sessionStorage.setItem('databus-local-save', JSON.stringify(newSave));
};

export const setStorage = (key: string, value: any) => {
  const localString: string = window.sessionStorage.getItem('databus-local-save') || '';
  let localSave: any = localString ? JSON.parse(localString) : null;
  if (!localString || localSave.environment !== detectEnvironment()) {
    overwriteStorage(key, value);
    return;
  }
  localSave[key] = value;
  window.sessionStorage.setItem('databus-local-save', JSON.stringify(localSave));
};

export const getStorage = (key: string) => {
  const localString: string = window.sessionStorage.getItem('databus-local-save') || '';
  if (!localString) {
    overwriteStorage();
    return null;
  }
  let localSave: any = localString ? JSON.parse(localString) : null;
  if (localSave?.environment === detectEnvironment() && localSave[key]) {
    return localSave[key];
  }
  return null;
};

export const getSessionStorageOnActiveOrg = (key: string) => {
  const localString: string = window.sessionStorage.getItem('databus-local-save') || '';
  if (!localString) {
    overwriteStorage();
    return null;
  }
  const localSave: any = JSON.parse(localString);
  if (localSave?.environment === detectEnvironment() && localSave?.activeOrg) {
    return localSave?.activeOrg[key];
  }
  return null;
};

export const removeFromStorage = (key: string) => {
  const localString: string = window.sessionStorage.getItem('databus-local-save') || '';
  if (!localString) {
    overwriteStorage();
    return null;
  }
  let localSave: any = localString ? JSON.parse(localString) : null;
  if (localSave?.environment === detectEnvironment() && localSave[key]) {
    delete localSave[key];
    window.sessionStorage.setItem('databus-local-save', JSON.stringify(localSave));
    return true;
  }
  return null;
};

export const getSearchParam = (param: string): string | null => {
  return new URLSearchParams(window.location.search).get(param);
};
